jQuery(function ($) {
    $(document).ready(function () {

        /**
         * Inputs focus effects
         */
        let from_row_input = $(".form-row input, .form-row select, .form-row textarea");
        from_row_input.attr("placeholder", "");
        from_row_input.attr("data-placeholder", "");
        from_row_input.each(function () {
            if ($(this).val() == "") {
                $(this).closest('p').find('label').removeClass('focus');
            } else {
                $(this).closest('p').find('label').addClass('focus');
            }
        });
        from_row_input.focus(function () {
            $(this).closest('p').find('label').addClass('focus');
        });
        from_row_input.focusout(function () {
            if ($(this).val() == "") {
                $(this).closest('p').find('label').removeClass('focus');
            }
        });

    });
});